import { inject, Injectable } from '@angular/core';
import { AuthActions, AuthState, ObjectState, UserInitializationService } from '@meddev/fe-shared';
import { Store } from '@ngxs/store';
import { AuthServiceClientService, AuthStateEnum, MCAAuthActions, UserStatusMapper } from '@shared/data';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MclUserInitializationService extends UserInitializationService {
    private readonly store = inject(Store);
    private readonly authServiceClient = inject(AuthServiceClientService);
    private readonly userStatusMapper = inject(UserStatusMapper);

    constructor() {
        super();
    }

    initializeUserData() {
        return this.authServiceClient.getUserInfo().pipe(
            withLatestFrom(this.store.select(AuthState.realm$)),
            switchMap(([userInfo, realm]) => {
                if (!userInfo) {
                    return of(null);
                }

                this.store.dispatch(new MCAAuthActions.SetUserInfo(userInfo));

                if (realm?.name !== 'MCL') {
                    return of(null);
                }

                return this.authServiceClient.getUserStatus(userInfo.id).pipe(
                    map(userStatusDto => this.userStatusMapper.mapDtoToModel(userStatusDto)),
                    switchMap(userStatus => this.store.dispatch(new MCAAuthActions.SetUserStatus(userStatus)).pipe(map(() => null))),
                    catchError(() => {
                        this.store.dispatch(new MCAAuthActions.SetUserStatus(null));
                        return of(null);
                    }),
                );
            }),
            catchError(() => {
                this.store.dispatch(new MCAAuthActions.SetUserInfo(null));
                this.store.dispatch(new MCAAuthActions.SetUserStatus(null));
                return of(null);
            }),
        );
    }

    clearUserData() {
        return this.store.dispatch(new MCAAuthActions.SetUserInfo(null)).pipe(
            switchMap(() => this.store.dispatch(new MCAAuthActions.SetUserStatus(null))),
            switchMap(() => this.store.dispatch(new AuthActions.SetChallenge(null))),
            switchMap(() => this.store.dispatch(new AuthActions.SetChallengeParams(null))),
            switchMap(() => this.store.dispatch(new AuthActions.SetAuthState({ state: ObjectState.VALID, value: AuthStateEnum.CHALLENGE }))),
            map(() => null),
        );
    }
}
